import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import '../../shared/css/generic-styles.css';
import '../../shared/css/Label.css';
import '../../shared/css/Text.css';
import { Footnote } from './Text';
import { Space } from './Space';
import { VStack } from './Stack';
/**
 * # Label
 * A flexible and reusable label component with ratio-based spacing.
 */
var Label = function (_a) {
    var children = _a.children, title = _a.title, label = _a.label, _b = _a.horizontal, horizontal = _b === void 0 ? false : _b, ratio = _a.ratio, _c = _a.labelClass, labelClass = _c === void 0 ? 'Subhead' : _c, _d = _a.labelColor, labelColor = _d === void 0 ? 'text-secondary' : _d, _e = _a.width, width = _e === void 0 ? 'fill' : _e, helperText = _a.helperText, error = _a.error, onErrorResolve = _a.onErrorResolve;
    var handleChildClick = function (event) {
        if (error && onErrorResolve) {
            onErrorResolve();
        }
    };
    useEffect(function () {
        if (label) {
            console.warn('Warning: The "label" prop in Label component is deprecated and will be removed in a future version. ' +
                'Please use the "title" prop instead. ' +
                'See the component documentation or codebase for more details. ' +
                'Usage detected at:', new Error().stack);
        }
    }, [label]);
    var style = horizontal && ratio
        ? {
            display: 'grid',
            gridTemplateColumns: "".concat(ratio[0], "fr ").concat(ratio[1], "fr"),
            gap: 'var(--ts-space-content)',
        }
        : undefined;
    return (_jsx(VStack, { group: true, className: '', width: width, children: _jsxs("div", { className: "nested ".concat(!horizontal ? 'v-stack' : 'h-stack middle', " width-").concat(width, " ").concat(error ? 'error' : ''), style: style, children: [horizontal ?
                    _jsxs(VStack, { children: [_jsx("label", { className: "text ".concat(labelClass.toLowerCase(), " color-").concat(labelColor, " width-").concat(width), children: label ? label : title }), helperText && horizontal && _jsx(Footnote, { color: error ? 'negative' : 'text-secondary', children: helperText })] })
                    :
                        _jsx("label", { className: "text ".concat(labelClass.toLowerCase(), " color-").concat(labelColor, " width-").concat(width), children: label ? label : title }), children && !horizontal && _jsx(Space.Content, {}), children && horizontal && !ratio && _jsx(Space.Content, {}), children && (_jsxs("div", { onClick: handleChildClick, className: "label-content v-stack width-".concat(width, " ").concat(horizontal ? 'right' : 'left'), children: [children, helperText && !horizontal && _jsx(Footnote, { color: error ? 'negative' : 'text-secondary', children: helperText })] }))] }) }));
};
export { Label };
